import { useDisclosure } from "@/hooks";
import { useUpdateMeditator } from "@/hooks/query-hooks/useMeditators";
import { Button, Form, Modal } from "antd";
import { MeditatorForm, MeditatorFormValues } from "./MeditatorForm";

export function EditMeditatorModal({ meditator }: { meditator: Meditator }) {
	const [opened, { toggle }] = useDisclosure();

	const [form] = Form.useForm<MeditatorFormValues>();
	const { mutate, isLoading: isUpdating } = useUpdateMeditator();

	const onSubmit = (data: AddNewMeditatorRequest) => {
		const payload = {
			id: meditator.id,
			data,
		};

		mutate(payload, {
			onSuccess: () => {
				onCloseModal();
			},
		});
	};

	const onCloseModal = () => {
		toggle();
	};

	return (
		<>
			<Button type="link" size="small" onClick={toggle}>
				Edit
			</Button>
			<Modal
				open={opened}
				onCancel={onCloseModal}
				title="ယောဂီ အချက်အလက်ပြင်ဆင်ရန်"
				centered
				width={740}
				okText="အတည်ပြုမည်"
				cancelText="ပယ်ဖျက်မည်"
				destroyOnClose
				okButtonProps={{
					type: "primary",
					htmlType: "submit",
					form: `edit-meditator-form-${meditator.id}`,
					className: "bg-primary-gradient",
					size: "large",
					shape: "round",
					loading: isUpdating,
				}}
				cancelButtonProps={{
					size: "large",
					shape: "round",
					disabled: isUpdating,
				}}
				maskClosable={!isUpdating}
			>
				<MeditatorForm
					form={form}
					onSubmit={onSubmit}
					formName={`edit-meditator-form-${meditator.id}`}
					initialValues={{
						...meditator,
						nrc: meditator.nrcNo,
						// dob: dayjs(meditator.dob, Array.from(POSSIBLE_DATE_FORMATS)).isValid() ? dayjs(meditator.dob, Array.from(POSSIBLE_DATE_FORMATS)) : undefined,
						levelId: meditator.level?.id || 1,
						bookNo: meditator.book?.bookNo,
					}}
				/>
			</Modal>
		</>
	);
}
